import useAppRouteHref from '../../../app/useAppRouteHref';

export const useProfileRouteGoBackTo = () => {
  return useAppRouteHref('/profile');
};

export default useProfileRouteGoBackTo;
